/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetProducts200ResponseItemsInnerSchedulesInner
 */
export interface GetProducts200ResponseItemsInnerSchedulesInner {
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInnerSchedulesInner
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProducts200ResponseItemsInnerSchedulesInner
     */
    days: Array<GetProducts200ResponseItemsInnerSchedulesInnerDaysEnum>;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInnerSchedulesInner
     */
    hourFrom: string;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInnerSchedulesInner
     */
    hourTo: string;
}


/**
 * @export
 */
export const GetProducts200ResponseItemsInnerSchedulesInnerDaysEnum = {
    Monday: 'monday',
    Tuesday: 'tuesday',
    Wednesday: 'wednesday',
    Thursday: 'thursday',
    Friday: 'friday',
    Saturday: 'saturday',
    Sunday: 'sunday'
} as const;
export type GetProducts200ResponseItemsInnerSchedulesInnerDaysEnum = typeof GetProducts200ResponseItemsInnerSchedulesInnerDaysEnum[keyof typeof GetProducts200ResponseItemsInnerSchedulesInnerDaysEnum];


/**
 * Check if a given object implements the GetProducts200ResponseItemsInnerSchedulesInner interface.
 */
export function instanceOfGetProducts200ResponseItemsInnerSchedulesInner(value: object): value is GetProducts200ResponseItemsInnerSchedulesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('days' in value) || value['days'] === undefined) return false;
    if (!('hourFrom' in value) || value['hourFrom'] === undefined) return false;
    if (!('hourTo' in value) || value['hourTo'] === undefined) return false;
    return true;
}

export function GetProducts200ResponseItemsInnerSchedulesInnerFromJSON(json: any): GetProducts200ResponseItemsInnerSchedulesInner {
    return GetProducts200ResponseItemsInnerSchedulesInnerFromJSONTyped(json, false);
}

export function GetProducts200ResponseItemsInnerSchedulesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProducts200ResponseItemsInnerSchedulesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'days': json['days'],
        'hourFrom': json['hourFrom'],
        'hourTo': json['hourTo'],
    };
}

export function GetProducts200ResponseItemsInnerSchedulesInnerToJSON(json: any): GetProducts200ResponseItemsInnerSchedulesInner {
    return GetProducts200ResponseItemsInnerSchedulesInnerToJSONTyped(json, false);
}

export function GetProducts200ResponseItemsInnerSchedulesInnerToJSONTyped(value?: GetProducts200ResponseItemsInnerSchedulesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'days': value['days'],
        'hourFrom': value['hourFrom'],
        'hourTo': value['hourTo'],
    };
}

